// 用途: Angular の未捕捉例外を FirebaseCrashlyticsService に橋渡しするグローバルエラーハンドラー。

import { ErrorHandler, inject, Injectable } from '@angular/core';
import { FirebaseCrashlyticsService } from '@app/shared/services/firebase-crashlytics.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // ガイドラインに従い inject() を使用
  private readonly crashlytics = inject(FirebaseCrashlyticsService);

  handleError(error: unknown): void {
    // Crashlytics へ非致命的エラーとして送信
    void this.crashlytics.recordException(error, 'error');
    // 既存のコンソール出力も保持（開発時に視認可能）
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
